import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { colors, fontFamily, fontSizes, fontWeights, layout, radii } from '../../theme/tokens';
import { LOGO_IMAGES } from '../../config/imagePaths';
import { useIsMobile } from '../../hooks/useMediaQuery';
import { Container } from '../ui';
import LoginModal from '../auth/LoginModal';

// School-browsing pages that logged-out visitors can open (login is only asked for at Add to cart).
export const isPublicBrowsePath = (pathname) =>
  pathname === '/search' || pathname.startsWith('/school/') || pathname.startsWith('/grade/');

// Top bar for logged-out visitors: logo on the left, School Zone + Login on the right.
const PublicHeader = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [loginOpen, setLoginOpen] = useState(false);

  const btn = (filled) => ({
    height: isMobile ? 44 : 48, padding: isMobile ? '0 16px' : '0 24px', borderRadius: radii.button,
    border: '1px solid ' + colors.navy, background: filled ? colors.navy : colors.white,
    color: filled ? colors.white : colors.navy, fontFamily, fontSize: fontSizes.body,
    fontWeight: fontWeights.semibold, cursor: 'pointer', whiteSpace: 'nowrap',
  });

  return (
    <header style={{ background: colors.white, borderBottom: '1px solid ' + colors.border, position: 'relative', zIndex: 50 }}>
      <Container
        style={{
          height: isMobile ? layout.headerHeightMobile : layout.headerHeight, display: 'flex',
          alignItems: 'center', justifyContent: 'space-between', gap: 12,
        }}
      >
        <Link to="/" aria-label="VidyarthiKart home" style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <img
            src={LOGO_IMAGES.LOCKUP}
            alt="VidyarthiKart - Official book partner"
            style={{ height: isMobile ? 44 : 64, width: 'auto', objectFit: 'contain', display: 'block' }}
          />
        </Link>
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 8 : 12 }}>
          <button type="button" style={btn(true)} onClick={() => navigate('/search')}>
            School Zone
          </button>
          <button type="button" style={btn(false)} onClick={() => setLoginOpen(true)}>
            Login
          </button>
        </div>
      </Container>
      <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />
    </header>
  );
};

export default PublicHeader;
